<template>
	<div>
		<div class="wrapper">
			<div class="homeCon1">
				<div class="bannerSwiper clear">
					<div class="swiper-wrapper">
							<div class="swiper-slide">
								<router-link :to="{ name:'productGszc' }">
									<img src="../../assets/images/home/banner1.png" alt="">
								</router-link>
							</div>
							<div class="swiper-slide">
								<router-link :to="{ name:'productDskfwb' }">
									<img src="../../assets/images/home/banner2.png" alt="">
								</router-link>
							</div>
							<div class="swiper-slide">
								<router-link :to="{ name:'productSwch' }">
									<img src="../../assets/images/home/banner3.png" alt="">
								</router-link>
							</div>
							<div class="swiper-slide">
								<router-link :to="{ name:'productDljz' }">
									<img src="../../assets/images/home/banner4.png" alt="">
								</router-link>
							</div>
					</div>
					<!-- 如果需要分页器 -->
				  <div class="swiper-pagination"></div>
				</div>
				<!-- <img src="../../assets/images/home/logo.png" alt="" class="logoImg" />	 -->
				<p class="logoImg">
					<img src="../../assets/images/logo/img_12.png" alt="" class="logoImg1" />
					<span class="logoTxt">
						<img src="../../assets/images/logo/img_10.png" alt="" class="wow fadeIn" data-wow-delay="0.2s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.2s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_9.png" alt="" class="wow fadeIn" data-wow-delay="0.3s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.3s; animation-name: fadeIn; margin-top: 1px;"  />
						<img src="../../assets/images/logo/img_8.png" alt="" class="wow fadeIn" data-wow-delay="0.4s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.4s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_7.png" alt="" class="wow fadeIn" data-wow-delay="0.5s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.5s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_6.png" alt="" class="wow fadeIn" data-wow-delay="0.6s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.6s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_5.png" alt="" class="wow fadeIn" data-wow-delay="0.7s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.7s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_4.png" alt="" class="wow fadeIn" data-wow-delay="0.8s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.8s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_3.png" alt="" class="wow fadeIn" data-wow-delay="0.9s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 0.9s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_2.png" alt="" class="wow fadeIn" data-wow-delay="1s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 1s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_1.png" alt="" class="wow fadeIn" data-wow-delay="1.1s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 1.1s; animation-name: fadeIn;" />
						<img src="../../assets/images/logo/img_0.png" alt="" class="wow fadeIn" data-wow-delay="1.2s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 1.2s; animation-name: fadeIn;" />
					</span>
					<img src="../../assets/images/logo/img_11.png" class="logoLine wow fadeIn"  data-wow-delay="1.3s" style="animation-duration: 1.2s; visibility: visible; animation-delay: 1.3s; animation-name: fadeIn;"/>
				</p>
				
				
				<div class="moreDiv" @click="moreToggle">
					<div class="moreDiv_main" v-show="moreFlag">
						<i class="topPoint"></i>
						<ul>
							<li>
								 <router-link :to="{ name:'productPage' }">
								    <i class="more_cplb v-2"></i>
								    <span>产品列表</span>
								</router-link>
							</li>
							<li @click="toMustLogin('/problem/wyTousu')">
								 <i class="more_wyts v-2"></i>
								  <span>我要投诉</span>
							</li>
							<li @click="toMustLogin('/problem/wyTiwen')">
							    <i class="more_wytw v-2"></i>
							    <span>我要提问</span>
							</li>
							<li @click="toMustLogin('/problem/common')">
							    <i class="more_cjwt"></i>
							    <span>常见问题</span>
							</li>
							<li>
								<router-link :to="{ name:'zixunPage' }">
								    <i class="more_hyzx v-2"></i>
								    <span>行业资讯</span>
							    </router-link>
							</li>
							<li style="border-bottom: 0;">
								 <router-link :to="{ name:'aboutPage' }">
								    <i class="more_gywm v-2"></i>
								    <span>关于我们</span>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
				
				<div class="productType">
					<router-link :to="{ name:'productGszc' }">
						<p>
							<img src="../../assets/images/home/model1.png" alt="">
							<span>公司注册</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productQybg' }">
						<p>
							<img src="../../assets/images/home/model2.png" alt="">
							<span>企业变更</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productDljz' }">
						<p>
							<img src="../../assets/images/home/model3.png" alt="">
							<span>代理记账</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productSwch' }">
						<p>
							<img src="../../assets/images/home/model4.png" alt="">
							<span>税务筹划</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productCszx' }">
						<p>
							<img src="../../assets/images/home/model5.png" alt="">
							<span>财税咨询</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productGszx' }">
						<p>
							<img src="../../assets/images/home/model6.png" alt="">
							<span>公司注销</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productSbkh' }">
						<p>
							<img src="../../assets/images/home/model7.png" alt="">
							<span>社保开户</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productPage' }">
						<p>
							<img src="../../assets/images/home/model8.png" alt="">
							<span>更多服务</span>
						</p>
					</router-link>
				</div>
			</div>
			
		  <div class="homeCon2 clear" style="margin-top: 12rem;">
				<p class="homeCon-title" style=" padding: 1.5rem 3% 0.4rem 3%;">优惠套餐</p>
				<router-link :to="{ name:'productMeal', params: {id:this.pid} }">
					<div class="homeCon2-div1">
						<p>企业变更+1年代理记账</p>
						<p v-if="mealProductPrice=='my'">面议<i class="v-2"></i></p>
						<p v-else>￥{{mealProductPrice}}<i class="v-2"></i></p>
					</div>
				</router-link>
			</div>
			
			<div class="homeCon3">
				<p class="homeCon-title">工商服务<a @click="goList(0)">更多&nbsp;></a></p>
				<div class="homeCon3-div1">
					<router-link :to="{ name:'productKzba' }">
						<div class="homeCon3-div1_l">
								<p>刻章备案</p>
								<p>
									<i v-if="kzbaPrice=='my'">
											面议
									</i>
									<i v-else>
											￥{{kzbaPrice}}
									</i>
								</p>
								<p><img src="../../assets/images/home/gsfw1.png" alt=""></p>
						</div>
					</router-link>
					<div class="homeCon3-div1_r">
							<router-link :to="{ name:'productNdgsnb' }">
								<div class="homeCon3-div1-div1">
									<p>
										<span>年度工商年报</span>
										<span>
											<i v-if="gsnbPrice=='my'">
												面议
											</i>
											<i v-else>
												￥{{gsnbPrice}}
											</i>
										</span>
									</p>
									<p><img src="../../assets/images/home/gsfw2.png" alt=""></p>
								</div>
							</router-link>
							<router-link :to="{ name:'productNdhsqj' }">
								<div class="homeCon3-div1-div1" style="margin-top: 0.65rem;">
									<p>
										<span>年度汇算清缴</span>
										<span>
											<i v-if="hsqjPrice=='my'">
												面议
											</i>
											<i v-else>
												￥{{hsqjPrice}}
											</i>
										</span>
									</p>
									<p><img src="../../assets/images/home/gsfw3.png" alt=""></p>
								</div>
							</router-link>
					</div>
				</div>
			</div>
			
			<div class="homeCon4 clear">
				<p class="homeCon-title">开户服务<a @click="goList(1)">更多&nbsp;></a></p>
				<router-link to="/product/product-sbkh">
					<div class="homeCon4-div1 homeCon4-div1-a1">
						<p>
							<span>社保开户</span>
							<span>
								<i v-if="sbkhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{sbkhPrice}}
								</i>
							</span>
						</p>
						<p>
							<img src="../../assets/images/home/khfu_icon1.png" alt="">
						</p>
					</div>
				</router-link>
				<router-link to="/product/product-ksybh">
					<div class="homeCon4-div1 homeCon4-div1-a2">
						<p>
							<span>开设一般户</span>
							<span style="color: #F9AD4B;">
								<i v-if="ksybhPrice=='my'">
									面议
								</i>
								<i v-else>
									￥{{ksybhPrice}}
								</i>
							</span>
						</p>
						<p>
							<img src="../../assets/images/home/khfu_icon2.png" alt="">
						</p>
					</div>
				</router-link>
			</div>
			<div class="homeCon5">
				<p class="homeCon-title">财税服务<a @click="goList(2)">更多&nbsp;></a></p>
				<div class="homeCon5-div1">
					<router-link :to="{ name:'productFpsl' }">
						<div>
							<img src="../../assets/images/home/csfw_icon1.png" alt="">
							<p>发票申领</p>
							<p>
								<span v-if="fpslPrice=='my'">
										面议
								</span>
								<span v-else>
										￥{{fpslPrice}}
								</span>
							</p>
						</div>
					</router-link>
					<router-link :to="{ name:'productSwjf' }">
						<div>
							<img src="../../assets/images/home/csfw_icon2.png" alt="">
							<p>税务解非</p>
							<p>
								<span v-if="swjfPrice=='my'">
										面议
								</span>
								<span v-else>
										￥{{swjfPrice}}
								</span>
							</p>
						</div>
					</router-link>
					<router-link :to="{ name:'productNbycjf' }">
						<div style="margin-right: 0;">
							<img src="../../assets/images/home/csfw_icon3.png" alt="">
							<p>年报异常解非</p>
							<p>
								<span v-if="nbycjfPrice=='my'">
										面议
								</span>
								<span v-else>
										￥{{nbycjfPrice}}
								</span>
							</p>
						</div>
					</router-link>
				</div>
			</div>
			
			<div class="homeCon6 clear">
				<p class="homeCon-title">其他服务<a @click="goList(3)">更多&nbsp;></a></p>
				<div class="homeCon6-div1">
					<router-link :to="{ name:'productJwtz' }">
						<p>
							<img src="../../assets/images/home/qtfw1.png" alt="">
							<span>ODI境外投资</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productDskfwb' }">
						<p>
							<img src="../../assets/images/home/qtfw2.png" alt="">
							<span>电商客服外包</span>
						</p>
					</router-link>
					<router-link :to="{ name:'productSpjyxkz' }">
						<p>
							<img src="../../assets/images/home/qtfw3.png" alt="">
							<span>食品经营许可证</span>
						</p>
					</router-link>
				</div>
			</div>
			
			<div class="bottomDiv clear">
				<p>
					<a href="//www.lingfenxiang.com?pc">电脑端</a>
					<router-link  :to="{ name:'aboutPage'}" >
						关于我们
					</router-link>
					<router-link  :to="{ name:'zixunPage'}" >
						行业资讯
					</router-link>
				</p>
				<p>Copyright © 2011-{{currYear}} <a href="http://beian.miit.gov.cn" style="color:white">沪ICP备18035332号-2</a></p>
				<p>上海蜜瓣网络科技有限公司 版权所有</p>
			</div>
		</div>
		<footerTag />
		<router-link :to="{ name: 'kefuPage', params: {time: curTime}}">
			<img src="../../assets/images/home/kefu.png" alt="" class="kefu"/>
		</router-link>
	</div>
</template>

<script>
	import "../../assets/css/home.scss"
    import footerTag from '@/components/footerTag/footerTag.vue'
	import Swiper from 'swiper'
	 import {WOW} from 'wowjs'
	
  export default {
    name: 'homePage',
    props: {
       
    },
		data(){
		  return {
		  		currYear:new Date().getFullYear(),
		    	moreFlag:false,
				mealProductName:'企业变更+一年代理记账',
				mealProductPrice:'',
				kzbaPrice:'',
				gsnbPrice:'',
				hsqjPrice:'',
				sbkhPrice:'',
				ksybhPrice:'',
				fpslPrice:'',
				swjfPrice:'',
				nbycjfPrice:'',
				pid:'',
				curTime: new Date().getTime()
		  }
		},
    components: {
      footerTag,
    },
	methods: {
		goList(num){//定位到产品列表页
			this.$router.push({name:'productPage',params:{flag: num}})
		},
		toMustLogin(page){  //必须登录的页面的判断
			this.axios({
			    method: 'POST',
			    url:'/user/getUserName',
			}).then((res)=>{
					if(res.data.obj != null && res.data.obj != ''){
						// 用户已登录
						window.location.href=page;
					}else{
						//未登录
						window.location.href='/login?targetUrl='+page;
					}
			}).catch((err)=>{
				this.$message.error({message: '网络异常，请稍后重试'});
			})
		},
        moreToggle: function() {
          this.moreFlag = !this.moreFlag //取反
        },
		getMealProduct() {
			this.axios({
			    method: 'POST',
			    url:'/product/getMealProduct',
			}).then((res)=>{
					if(res.data.code==1000){
						 let data = res.data.data.mealProduct;
						 if(data != null){
						 	//this.mealProductName = data.productName;
						 	this.mealProductPrice = data.price;
						 	this.pid = data.pid;
						 }else{
						 	this.mealProductPrice="my";
						 }
					}
			}).catch((err)=>{
			    this.$message.error({message: '网络异常，请稍后重试'});
			})
		},
		getOtherProduct(){
			this.axios({
				method: 'POST',
				url:'/product/getOtherProduct',
				params:{
					type:0
				},
			}).then((res)=>{
					if(res.data.code==1000){
						let data = res.data.data;
						 //刻章备案
						if(data.kzba != null){
							this.kzbaPrice=data.kzba.price;
						}else{
							this.kzbaPrice='my';
						}
						//年度工商年报
						if(data.gsnb != null){
							this.gsnbPrice=data.gsnb.price;
						}else{
							this.gsnbPrice='my';
						}
						//年度汇算清缴
						if(data.hsqj != null){
							this.hsqjPrice=data.hsqj.price;
						}else{
							this.hsqjPrice='my';
						} 
						//社保开户
						if(data.sbkh != null){
							this.sbkhPrice=data.sbkh.price;
						}else{
							this.sbkhPrice='my';
						}
						//开设一般户
						if(data.ksybh != null){
							this.ksybhPrice=data.ksybh.price;
						}else{
							this.ksybhPrice='my';
						}
						//发票申领
						if(data.fpsl != null){
							this.fpslPrice=data.fpsl.price;
						}else{
							this.fpslPrice='my';
						}
						//税务解非
						if(data.swjf != null){
							this.swjfPrice=data.swjf.price;
						}else{
							this.swjfPrice='my';
						}
						//年报异常解非
						if(data.nbycjf != null){
							this.nbycjfPrice=data.nbycjf.price;
						}else{
							this.nbycjfPrice='my';
						}
					}	
			}).catch((err)=>{
				  this.$message.error({message: '网络异常，请稍后重试'});
			})
		},
	},
	mounted(){
			var bannerSwiper = new Swiper('.bannerSwiper', {
									  loop: true,
										autoplay: {
											delay: 3000,
											stopOnLastSlide: false,
											disableOnInteraction: false
										},
										// 如果需要分页器
										pagination: {
											el: '.swiper-pagination',
											clickable: true,
										},
			});
			 this.getMealProduct();
			 this.getOtherProduct();
			 new WOW().init();
		}
  }
</script>